// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"589":"5972ecc378b0a4260557","678":"8228fdb33117f237c689","883":"f446bd0bbef8117374df"}[chunkId] + ".js";
};